// Copyright (c) 2017 Deere & Company

import AuditResult, {getDefaultState as getAuditResultDefaultState} from '@deere/cps-it.warranty-model-factory/lib/audit-result';
import t from 'tcomb';

const AuditResultModal = t.struct({
    auditResult: AuditResult,
    isVisible: t.Boolean
}, 'AuditResultModalModal');

export const getDefaultState = () =>
    new AuditResultModal({
        auditResult: getAuditResultDefaultState(),
        isVisible: false
    });

export default AuditResultModal;



// WEBPACK FOOTER //
// ./src/reports/audit-summary/state/audit-result-modal.js